import { useEffect } from 'react';

// Component to redirect to PDF
export function PDFRedirect({ pdfUrl }) {
  useEffect(() => {
    window.location.href = pdfUrl;
  }, [pdfUrl]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      fontFamily: 'Montserrat, sans-serif',
      color: '#1b1e4f'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Ouverture du PDF...</h2>
        <p>Votre fichier PDF s'ouvre. Patientez s'il vous plaît.</p>
      </div>
    </div>
  );
}

export default PDFRedirect;
